<script>
  import { onDestroy } from 'svelte';
  import PersonalNoteSections from './PersonalNoteSections.svelte';
  import { createPersonalNotesApi, classDescription } from './personalNotes.js';
  import { getApiBase } from './apiBase.js';
  export let teacherId;
  let loadedTeacher, rows = [], nextCursor = null, loading = false, error = '', selected = null, detailLoading = false;
  let requestVersion = 0, detailVersion = 0, destroyed = false;
  const api = createPersonalNotesApi({ apiBase: getApiBase(), token: localStorage.getItem('jwtToken') });
  $: if (teacherId && teacherId !== loadedTeacher) {
    loadedTeacher = teacherId;
    rows = [];
    selected = null;
    detailVersion++;
    detailLoading = false;
    nextCursor = null;
    load(true);
  }
  async function load(reset = false) {
    const version = ++requestVersion;
    loading = true;
    error = '';
    try {
      const result = await api.adminList(teacherId, reset ? null : nextCursor);
      if (destroyed || version !== requestVersion) return;
      rows = reset ? result.results : [...rows, ...result.results];
      nextCursor = result.next_cursor;
    } catch (err) { if (!destroyed && version === requestVersion) error = err.message; }
    finally { if (!destroyed && version === requestVersion) loading = false; }
  }
  async function select(row) {
    const version = ++detailVersion;
    detailLoading = true;
    error = '';
    selected = null;
    try {
      const result = await api.adminRead(teacherId, row.note_id);
      if (!destroyed && version === detailVersion) selected = result;
    } catch (err) { if (!destroyed && version === detailVersion) error = err.message; }
    finally { if (!destroyed && version === detailVersion) detailLoading = false; }
  }
  onDestroy(() => { destroyed = true; });
</script>

<section class="admin-personal-notes" aria-label="Mokytojo asmeniniai užrašai">
  <h3>Asmeniniai pamokų užrašai</h3>
  <p>Administratoriaus peržiūra · tik skaitymui.</p>
  {#if error}<p role="alert">{error}</p><button type="button" on:click={() => load(true)}>Bandyti dar kartą</button>{/if}
  {#if loading}<p>Įkeliama...</p>{/if}
  {#if !loading && !error && rows.length === 0}<p>Asmeninių užrašų nėra.</p>{/if}
  <ul>{#each rows as row (row.note_id)}<li><button type="button" on:click={() => select(row)}>
    <strong>{row.class_info.title}</strong><span>{classDescription(row.class_info)}</span>
  </button></li>{/each}</ul>
  {#if nextCursor}<button type="button" disabled={loading} on:click={() => load()}>Rodyti daugiau</button>{/if}
  {#if detailLoading}<p>Įkeliami užrašai...</p>{/if}
  {#if selected}
    <article aria-label="Asmeninių užrašų peržiūra">
      <h4>{selected.class_info.title}</h4><p>{classDescription(selected.class_info)}</p>
      <PersonalNoteSections sections={selected.sections} readonly />
    </article>
  {/if}
</section>

<style>
  .admin-personal-notes { margin: 24px 0; padding: 20px; border: 1px solid #d2d4c6; border-radius: 8px; background: #faf9f3; color: #24251f; }
  ul { padding: 0; list-style: none; max-height: 360px; overflow: auto; }
  button { display: flex; flex-direction: column; gap: 6px; text-align: left; padding: 10px 14px; margin: 6px 0; max-width: 100%; background: white; color: inherit; border: 1px solid #b8bdac; border-radius: 5px; cursor: pointer; overflow-wrap: anywhere; }
  article { margin-top: 20px; border-top: 1px solid #b8bdac; }
  span { font-size: 13px; }
</style>
